<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="workInformationForm" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="创建人姓名" prop="WorkInformation.createUserName">
            <el-input class="input-item" v-model="formData.WorkInformation.createUserName"
                      :clearable="true" placeholder="创建人姓名"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="WorkInformation.workContent">
            <el-input class="input-item" v-model="formData.WorkInformation.workContent"
                      :clearable="true" placeholder="内容"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件" prop="WorkInformation.attachedFiles">
            <el-upload
              class="upload-image-item upload-image-multi" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/workInformation/upload')"
              :data="{fieldName: 'attachedFiles', asImage: true}"
              :on-success="onAttachedFilesUploadSuccess"
              :on-remove="onAttachedFilesRemoveFile"
              :before-upload="pictureFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              list-type="picture-card" :file-list="workInformationForm.attachedFiles.impl.fileList" :limit="workInformationForm.attachedFiles.impl.maxCount"
              :show-file-list="true">
              <i class="el-icon-plus upload-image-item"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工作地点" prop="WorkInformation.workLocation">
            <el-input class="input-item" v-model="formData.WorkInformation.workLocation"
                      :clearable="true" placeholder="工作地点"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('workInformationForm:workInformationForm:update')"
                       @click="onUpdateClick()">
              编辑
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { WorkInformationController, DictionaryController } from '@/api';

export default {
  name: 'workInformationForm',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        WorkInformation: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          createUserName: undefined,
          workType: undefined,
          workSubject: undefined,
          workContent: undefined,
          attachedFiles: undefined,
          viewNumber: undefined,
          workLocation: undefined,
          longitude: undefined,
          latitude: undefined,
          isDatasourceInit: false
        }
      },
      workInformationForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        attachedFiles: {
          impl: new UploadWidget(3)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
       * 更新工作日志表单
       */
    refreshWorkInformationForm (reloadData = false) {
      this.loadWorkInformationData().then(res => {
        if (!this.workInformationForm.isInit) {
          // 初始化下拉数据
        }
        this.workInformationForm.isInit = true;
      }).catch(e => {});
    },
    /**
       * 编辑
       */
    onUpdateClick () {
      this.$refs.workInformationForm.validate((valid) => {
        if (!valid) return;
        let params = {
          workInformationDto: {
            id: this.id,
            workLocation: this.formData.WorkInformation.workLocation,
            workContent: this.formData.WorkInformation.workContent,
            attachedFiles: this.formData.WorkInformation.attachedFiles
          }
        };

        WorkInformationController.update(this, params).then(res => {
          this.$message.success('编辑成功');
          this.refreshWorkInformationForm();
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshWorkInformationForm(true);
    },
    /**
       * 获取实时农事工作日志表详细信息
       */
    loadWorkInformationData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.WorkInformation.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          WorkInformationController.view(this, params).then(res => {
            this.formData.WorkInformation = {...res.data, isDatasourceInit: true};
            let attachedFilesDownloadParams = {
              id: this.formData.WorkInformation.id,
              fieldName: 'attachedFiles',
              asImage: true
            }
            this.workInformationForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.WorkInformation.attachedFiles, attachedFilesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.WorkInformation.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
       * 附件上传成功
       */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.workInformationForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.WorkInformation.attachedFiles = this.fileListToJson(this.workInformationForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除附件
       */
    onAttachedFilesRemoveFile (file, fileList) {
      this.workInformationForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.WorkInformation.attachedFiles = this.fileListToJson(this.workInformationForm.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
       * 重置表单数据
       */
    resetFormData () {
      this.formData = {
        WorkInformation: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          createUserName: undefined,
          workType: undefined,
          workSubject: undefined,
          workContent: undefined,
          attachedFiles: undefined,
          viewNumber: undefined,
          workLocation: undefined,
          longitude: undefined,
          latitude: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshWorkInformationForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
